import { blockAtomNode } from '#src/tiptap/nodes/shared.ts'

export const EncounterMedicationsBlockNode = blockAtomNode(
  'encounter-medications-block'
)
